import service from '@/services';

export const getTipoCobertura = async () => {
  try {
    const result = await service.get('tipo-cobertura', '');
    return result;
  } catch (_e) {
    return {
      error: 'Não foi possível carregar os dados. Tente novamente mais tarde.',
    };
  }
};
